import httpClient from '@/http-client'

export const viewData = (options = {}) => {
    return httpClient
        .get('/api/reports/driver-performances', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { viewData }
